module.exports = __webpack_public_path__ + "static/media/use_esim_zhtw2.c0a64762.png";